import { useCallback, useEffect, useState } from "react";
import {
  Container,
  Grid,
  IconButton,
  Pagination,
  Paper,
  Typography,
} from "@mui/material";
import { DadosSolicitacaoPessoal } from "../../model/entities/SolicitacaoPessoal";

import TableGeneric from "../../components/Generics/TableGeneric";
import { GridColDef, GridSortModel } from "@mui/x-data-grid";
import { formatarData, useIsSmallScrenn } from "../../helper";
import { useSnack } from "../../redux/snack/snackHooks";
import solicitacaoPessoalApi from "../../api/solicitacaoPessoalApi";
import Titulo2 from "../../components/Generics/Titulo2";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ModalSolicitacaoPessoal from "../../components/modais/ModalSolicitacaoPessoal";
import LoadingBackdrop from "../../components/Generics/LoadingBackdrop";
import GridCenter from "../../components/Generics/GridCenter";
import dayjs from "dayjs";

type Props = {};

const SolicitacaoPessoalPage: React.FC<Props> = (props) => {
  const isSmallScrenn = useIsSmallScrenn();
  const [solicitacoes, setSolicitacoes] = useState<DadosSolicitacaoPessoal[]>(
    []
  );
  const [totalLinhas, setTotalLinhas] = useState(0);
  const [loading, setLoading] = useState(false);
  const [pagina, setPagina] = useState(1);
  const [linhasPorPagina, setLinhasPorPagina] = useState(0);
  const [manutencaoSelecionada, setManutencaoSelecionada] =
    useState<DadosSolicitacaoPessoal | null>(null);
  const [openModal, setOpenModal] = useState(false);
  const [sortModel, setSortModel] = useState<GridSortModel>([
    { field: "id", sort: "desc" },
  ]);
  const mostrarSnack = useSnack();
  const rowHeight = 52; //

  useEffect(() => {
    const calcularPageSize = () => {
      const alturaHeader = 56;
      const alturaFooter = 52;
      const alturaDisponivel =
        window.innerHeight - alturaHeader - alturaFooter - 200;

      const linhasVisiveis = Math.floor(alturaDisponivel / rowHeight);
      setLinhasPorPagina(linhasVisiveis > 0 ? linhasVisiveis : 1);
    };

    calcularPageSize();
    window.addEventListener("resize", calcularPageSize);
    return () => {
      window.removeEventListener("resize", calcularPageSize);
    };
  }, []);

  const buscarSolicitacoes = async () => {
    try {
      setLoading(true);
      const resTotal = await solicitacaoPessoalApi.count();
      setTotalLinhas(resTotal);

      let field = sortModel?.[0]?.field ?? "id";
      if (field === "nomeMotorista") field = "motorista";

      const res = await solicitacaoPessoalApi.getMany(
        pagina - 1,
        linhasPorPagina,
        field,
        sortModel?.[0]?.sort ?? "asc"
      );
      setSolicitacoes(res);
    } catch (erro: any) {
      mostrarSnack(
        "Ops! Aconteceu um problema ao buscar os solicitações!",
        "error"
      );
      console.log("erro ao buscar solicitacoes", erro);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    buscarSolicitacoes();
  }, [pagina, linhasPorPagina, sortModel?.[0]?.field, sortModel?.[0]?.sort]);

  if (loading) {
    return (
      <LoadingBackdrop
        open={loading}
        texto="Buscando solicitações pessoais ..."
      />
    );
  }

  const columns: GridColDef<DadosSolicitacaoPessoal>[] = [
    {
      field: "id",
      headerName: "ID",
      width: 50,
      editable: false,
    },
    {
      field: "nomeMotorista",
      headerName: "Motorista",
      width: 260,
      editable: false,
    },

    {
      field: "placaVeiculo",
      headerName: "Placa do Veículo",
      width: 150,
      editable: false,
    },

    {
      field: "dataHoraSolicitacao",
      headerName: "Data",
      editable: false,
      renderCell: (params) => {
        return formatarData(params.row.dataHoraSolicitacao.toString());
      },
    },

    {
      field: "acoes",
      headerName: "Ações",
      width: 80,
      editable: false,
      sortable: false,
      renderCell: (params) => {
        const solicitacao = params.row;
        return (
          <>
            <IconButton onClick={(e) => e.stopPropagation()}>
              <VisibilityIcon
                color="primary"
                onClick={(e) => {
                  e.stopPropagation();
                  setManutencaoSelecionada(solicitacao);
                  setOpenModal(true);
                }}
              />
            </IconButton>
          </>
        );
      },
    },
  ];

  return (
    <Grid spacing={2} style={{ display: "flex", justifyContent: "center" }}>
      <Container style={{ marginBottom: "15px" }}>
        <Grid item xs={12} style={{ textAlign: "center" }}>
          <Titulo2>Solicitações Pessoais </Titulo2>
        </Grid>

        {isSmallScrenn ? (
          <>
            {solicitacoes.map((solicitacao) => (
              <GridCenter>
                <Paper
                  style={{
                    margin: "12px 0px",
                    padding: "12px",
                    width: "100%",
                    borderRadius: "16px",
                  }}
                  key={solicitacao.id}
                >
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Typography fontWeight={"bold"}>
                        ID {solicitacao.id} | {solicitacao.nomeMotorista}
                      </Typography>
                    </Grid>

                    <Grid item xs={12}>
                      <Typography>
                        Placa do Veículo: {solicitacao.placaVeiculo}
                      </Typography>
                    </Grid>
                    {/* 
                    <Grid item xs={12}>
                      <Typography>
                        Prioridade: {solicitacao.prioridadePrograma}
                      </Typography>
                    </Grid>

                    <Grid item xs={12}>
                      <Typography>
                        Tipo do Veículo: {solicitacao.tipoVeiculo}
                      </Typography>
                    </Grid> */}

                    <Grid item xs={12}>
                      <Typography>
                        Data Solicitação{" "}
                        {dayjs(solicitacao.dataHoraSolicitacao).format(
                          "DD/MM/YYYY - HH:MM"
                        )}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "right" }}>
                      <IconButton>
                        <VisibilityIcon
                          color="primary"
                          onClick={(e) => {
                            e.stopPropagation();
                            setManutencaoSelecionada(solicitacao);
                            setOpenModal(true);
                          }}
                        />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Paper>
              </GridCenter>
            ))}
            <GridCenter>
              <Pagination
                size={"large"}
                defaultPage={1}
                count={totalLinhas / linhasPorPagina}
                onChange={(event, number) => setPagina(number)}
                page={pagina}
              />
            </GridCenter>
          </>
        ) : (
          <TableGeneric
            pageSize={linhasPorPagina}
            colunas={columns}
            linhas={solicitacoes}
            loading={loading}
            totalLinhas={totalLinhas}
            selecionaLinha={false}
            paginaAtual={pagina - 1}
            sx={{ height: "50%" }}
            rowHeight={52}
            setSortModel={setSortModel}
            sortModel={sortModel}
            onRowClick={(params) => {
              setManutencaoSelecionada(params.row);
              setOpenModal(true);
            }}
            formasDeListar={[5, 10]}
            setPaginacao={(model) => {
              setPagina(model.page);
              setLinhasPorPagina(model.pageSize);
            }}
          />
        )}
      </Container>

      {openModal && manutencaoSelecionada && (
        <ModalSolicitacaoPessoal
          open={openModal}
          dadosManutencao={manutencaoSelecionada}
          onClose={() => {
            buscarSolicitacoes();
            setOpenModal(false);
            setManutencaoSelecionada(null);
          }}
        />
      )}
    </Grid>
  );
};

export default SolicitacaoPessoalPage;
